import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

function fmtDeadline(d) {
  return new Date(d).toLocaleString('nl-NL', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
}

export default function PendingFormModal({ forms, onDismiss }) {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const form = forms[index];
  if (!form) return null;

  const isLast = index === forms.length - 1;

  const handleFillNow = () => {
    onDismiss();
    navigate(`/player/forms/${form.form_id}`);
  };
  const handleNext = () => {
    if (isLast) onDismiss();
    else setIndex(i => i + 1);
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 24 }}>
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 16, width: '100%', maxWidth: 380, padding: 24, boxShadow: '0 40px 80px rgba(0,0,0,0.6)', textAlign: 'center' }}>
        {forms.length > 1 && (
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 10 }}>{index + 1} of {forms.length}</div>
        )}
        {form.overdue && (
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: 'rgba(239,68,68,0.12)', color: '#ef4444', fontSize: 12, fontWeight: 700, padding: '4px 10px', borderRadius: 99, marginBottom: 12 }}>
            <AlertTriangle size={12} /> Overdue
          </div>
        )}
        <div style={{ fontSize: 40, marginBottom: 10 }}>📋</div>
        <h2 style={{ fontSize: 18, fontWeight: 700, margin: '0 0 6px' }}>{form.title}</h2>
        {form.description && <p style={{ fontSize: 13, color: 'var(--text-muted)', margin: '0 0 16px' }}>{form.description}</p>}
        {form.deadline && (
          <p style={{ fontSize: 12, color: form.overdue ? '#ef4444' : 'var(--text-dimmed)', marginBottom: 20 }}>
            {form.overdue ? 'Was due' : 'Due'} {fmtDeadline(form.deadline)}
          </p>
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <button onClick={handleFillNow}
            style={{ padding: '12px 20px', borderRadius: 12, border: 'none', background: '#3b82f6', color: '#fff', fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
            Fill now
          </button>
          <button onClick={handleNext}
            style={{ padding: '10px 20px', borderRadius: 12, border: 'none', background: 'transparent', color: 'var(--text-muted)', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
            {isLast ? 'Later' : 'Next'}
          </button>
        </div>
      </div>
    </div>
  );
}
